import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/auth/loginScreen.vue';
import DefaultPage from './views/DefaultPage.vue';
import ocrTreatment from './views/ocr/ocrTreatment.vue';
import usersScreen from './views/users/usersScreen.vue';
import dashboardScreen from './views/dashboard/DashboardScreen.vue';
import DocumentDetails from './views/dashboard/DocumentDetails.vue';
import NotFound from './views/404.vue';
import { TOKEN_KEY } from './utilsAuth';
import { hasFeature, isHaveRole } from "@/utils/permissions";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
        path: '/',
        redirect: '/login'
    },

    {
        path: '/default',
        name: 'DefaultPage',
        component: DefaultPage,
        meta: { requiresAuth: true, feature: 'DEFAULT', requiredRole: 'admin' }
    },

    {
        path: '/ocr',
        name: 'OCR-Treatmenr',
        component: ocrTreatment,
        meta: { requiresAuth: true, feature: 'DEFAULT', requiredRole: 'agent'}
    },

    {
        path: '/dashboard',
        name: 'Dashborad',
        component: dashboardScreen,
        meta: { requiresAuth: true, feature: 'DEFAULT', requiredRole: 'admin' }
    },


    {
        path: '/details',
        name: 'Details',
        component: DocumentDetails,
        meta: { requiresAuth: true, feature: 'DEFAULT', requiredRole: 'agent' },
        props: route => ({ id: route.query.id }) 
    },

    {
        path: '/users',
        name: 'Users',
        component: usersScreen,
        meta: { requiresAuth: true, feature: 'DEFAULT', requiredRole: 'admin' }
    },


    { path: '/login', component: Login },
    
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
    
      ]
});


router.beforeEach((to, from, next) => {
  const accessToken = Vue.$cookies.get(TOKEN_KEY);

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!accessToken) {
      if (to.path !== '/login') {
        next('/login');
        return;
      }
    } else {
      if (to.path === '/login') {
        next('/ocr');
        return;
      }

      const feature = to.meta.feature;
      if (feature && !hasFeature(feature)) {
        if (to.path !== '/dashboard') {
          next('/ocr');
          return;
        }
      }

      const requiredRole = to.meta.requiredRole;
      if (requiredRole && !isHaveRole(requiredRole)) {
        if (to.path !== '/ocr') {
          next('/ocr');
          return;
        }
      }
    }
  } else {
    if (accessToken && to.path === '/login') {
      next('/ocr');
      return;
    }
  }

  next();
});


export default router;
